import app from './firebase'
import {getAnalytics,isSupported} from 'firebase/analytics'

// A proxy that forwards calls to the real Analytics instance once it resolves,
// and silently no-ops if Analytics is unavailable (404, ad-blocker, etc.).
let _analytics=null

const analytics=new Proxy({},{
    get(_,prop) {
        if(_analytics) return _analytics[prop]
        // Return a no-op function for any property access before init
        return typeof prop==='string'? ()=>{} : undefined
    }
})

isSupported().then(supported => {
    if(supported) {
        try { _analytics=getAnalytics(app) } catch { /* unavailable */ }
    }
}).catch(()=>{})

export default analytics
